import React from "react";

function FinancialYearFilter({ value, onChange }) {
  return (
    <div className="col-md-3 mb-3">
      <label className="form-label">Financial Year*</label>
      <select
        className="form-select"
        name="financial_year"
        id="financial_year"
        value={value}
        onChange={onChange}
        required
      >
        <option value="">Choose...</option>
        <option value="2024">2024</option>
        <option value="2025">2025</option>
        <option value="2026">2026</option>
      </select>
    </div>
  );
}

export default FinancialYearFilter;
